import tree from "../../../components/tree.vue"
// import iColumn from "../../../components/Column.vue";
// import iTable from "../../../components/Table.vue";
// import IPagination from "../../../components/pagination.vue";
import { emailRule } from '@/utility/index.js'

export default {
    name: "userManagement",
    components: { tree },
    data() {
        return {
            formInline: {
                zhName: ''
            },
            tableData: [],
            //   currentPage: 1,
            //   pageSize: 10,
            //   total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                menuType: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseSelectSystem'), trigger: 'change' },
                ],
                name: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseEnterEnglishName'), trigger: 'blur' }
                ],
                zhName: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseEnterChineseName'), trigger: 'blur' }
                ],
                nodeType: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseSelectType'), trigger: 'change' }
                ],
                orderSort: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseSelectSorting'), trigger: 'change' }
                ],
                path: [
                    { required: true, message: this.$t('PlatformSettings.btn.pleaseEnterAddress'), trigger: 'blur' }
                ]
            },
            form: {
                menuType: '',
                name: '',
                zhName: '',
                nodeType: '',
                menuIcon: '',
                orderSort: '',
                path: ''
            },
            menuTypeList: [
                {
                    menuType: 0,
                    menuTypeName: '平台'
                },
                {
                    menuType: 1,
                    menuTypeName: 'app'
                },
            ],
            nodeTypeList: [
                {
                    nodeType: 0,
                    nodeTypeName: '模块'
                },
                {
                    nodeType: 1,
                    nodeTypeName: '页面'
                },
                {
                    nodeType: 2,
                    nodeTypeName: '按钮'
                }
            ],
            parentId: '',
            id: ''
            //   RoleList: [],
            //   dialogPowerVisible: false,
            //   data: [],
            //   defaultProps: {
            //     children: 'children',
            //     label: 'value',
            //   },
            //   keyList: [],
            //   filterText: '',
            //   selected: [],
            //   rolePower: '',
            //   companyId: '',
            //   diaHidden: false,

            //   isShow: true,
            //   isTrue: false,
        };
    },
    //   watch: {
    //     filterText(val) {
    //       this.$refs.tree.filter(val);
    //     }
    //   },
    created() {
        // this.getRole()
        // console.log(this.$route.params)
        // if (this.$route.params) {
        //   this.id = this.$route.params.id
        //   this.name = this.$route.params.name
        // }
        // if (sessionStorage.getItem("userType") == 0) {
        //   this.isShow = true
        // } else {
        //   this.isShow = false
        // }
    },
    mounted() {
        this.getUser()
    },
    methods: {
        getUser() {
            let param = {
                zhName: this.formInline.zhName,
            }
            this.$store.dispatch('MenuManagement/GET_SELECTMENUNODE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.tableData = res.data.data
                    }
                }
            })
        },
        onSearch() {
            this.currentPage = 1
            this.getUser()
        },
        onClear() {
            this.formInline = {
                zhName: '',
            }
            this.getUser()
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        // changeSize(item) {
        //   this.pageSize = item.pageSize
        //   this.currentPage = item.pageNum
        //   this.getUser();
        // },
        addMoudle() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'addMoudle'
            this.nodeTypeList = [
                {
                    nodeType: 0,
                    nodeTypeName: '模块'
                },
                {
                    nodeType: 1,
                    nodeTypeName: '页面'
                }
            ];
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })

        },
        handleAdd(row) {
            console.log(row)
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'addMenu'
            this.parentId = row.id
            if (row.nodeType == 0) {
                this.nodeTypeList = [
                    {
                        nodeType: 0,
                        nodeTypeName: '模块'
                    },
                    {
                        nodeType: 1,
                        nodeTypeName: '页面'
                    }
                ];
            } else if (row.nodeType == 1) {
                this.nodeTypeList = [
                    {
                        nodeType: 1,
                        nodeTypeName: '页面'
                    },
                    {
                        nodeType: 2,
                        nodeTypeName: "按钮",
                    },
                ];
            }
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        handleEdit(row) {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'editMenu'
            this.id = row.id
            if (row.nodeType == 0) {
                this.nodeTypeList = [
                    {
                        nodeType: 0,
                        nodeTypeName: '模块'
                    },
                    {
                        nodeType: 1,
                        nodeTypeName: '页面'
                    }
                ];
            } else if (row.nodeType == 1) {
                this.nodeTypeList = [
                    {
                        nodeType: 1,
                        nodeTypeName: '页面'
                    },
                    {
                        nodeType: 2,
                        nodeTypeName: "按钮",
                    },
                ];
            }
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.menuType = row.menuType
                this.form.name = row.name
                this.form.zhName = row.zhName
                this.form.nodeType = row.nodeType
                this.form.menuIcon = row.menuIcon
                this.form.orderSort = row.orderSort
                this.form.path = row.path
            })


        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        menuType: this.form.menuType,
                        name: this.form.name,
                        zhName: this.form.zhName,
                        nodeType: this.form.nodeType,
                        menuIcon: this.form.menuIcon,
                        orderSort: this.form.orderSort,
                        path: this.form.path
                    }
                    if (this.btnType == 'addMoudle') {
                        this.$store.dispatch('MenuManagement/GET_ADDMODULE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success({
                                    message: res.data.data,
                                    duration: 6000,
                                })
                                this.dialogFormVisible = false;
                                this.getUser();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else if (this.btnType == 'addMenu') {
                        param.parentId = this.parentId
                        this.$store.dispatch('MenuManagement/GET_ADDMENUNODE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success({
                                    message: res.data.data,
                                    duration: 6000,
                                })
                                this.dialogFormVisible = false;
                                this.getUser();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.id = this.id
                        this.$store.dispatch('MenuManagement/GET_UPDATEMENUNODE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success({
                                    message: res.data.data,
                                    duration: 6000,
                                })
                                this.dialogFormVisible = false;
                                this.getUser();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                menuType: '',
                name: '',
                zhName: '',
                nodeType: '',
                menuIcon: '',
                orderSort: '',
                path: ''
            }
        },
        closeDia() {
            this.form = {
                menuType: '',
                name: '',
                zhName: '',
                nodeType: '',
                menuIcon: '',
                orderSort: '',
                path: ''
            }
            this.dialogFormVisible = false;
        },
        // getRole() {
        //   this.$store.dispatch('roleManagement/GET_QUERY', {}).then(res => {
        //     if (res) {
        //       if (res.data.code == 200) {
        //         this.RoleList = res.data.data
        //       }
        //     }
        //   })
        // },
        // filterNode(value, data) {
        //   if (!value) return true;
        //   return data.value.indexOf(value) !== -1;
        // },
        // getTree() {
        //   let param = {
        //     orgId: sessionStorage.getItem("roleData"),
        //     companyId: sessionStorage.getItem("companyId"),
        //   }
        //   this.$store.dispatch('tree/GET_QUERYTREE', param).then(res => {
        //     if (res) {
        //       if (res.data.code == 200) {
        //         this.data = res.data.data
        //       }
        //     }
        //   })
        // },
        // getPower() {
        //   this.dialogPowerVisible = true
        //   this.diaHidden = true
        //   this.getTree()
        //   this.$nextTick(() => {
        //   })
        // },
        // submit(formName) {
        //   this.$refs[formName].validate((valid) => {
        //     if (valid) {
        //       this.form.roleData = this.$refs.tree.getCheckedKeys().join(',')
        //       console.log(this.form.roleData)
        //       this.dialogPowerVisible = false
        //       this.diaHidden = true
        //     } else {
        //       return false;
        //     }
        //   });
        // },
        // handCheck(currentNode, treeStatus) {
        // },
        // checkChange(val, checked) {
        // },
        // handleClose() {
        //   this.dialogPowerVisible = false
        //   this.diaHidden = false
        // },
        handleDelete(row) {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: row.id }
                    this.$store.dispatch('MenuManagement/GET_DELETEMENUNODE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getUser()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        // changeSort(item) {
        //   this.columns = [];
        //   this.$nextTick(function () {
        //     this.columns = item;
        //   });
        // },

        // ListSetting() {
        //   this.$refs.listSet.dialogVisible = true;
        // },
    },
};
